import React, { useCallback } from "react";

import { Button } from "capitalrx-components";

import apiService from "@/App/service";

interface Props {
  logKey: string | number | boolean | number[] | string[] | object | object[];
}

const ResponseLogSegment: React.FC<Props> = (props: Props) => {

  const handleLogsClick = useCallback((): void => {
    const payload = {
      id: -1,
      log_key: props.logKey as string,
    };

    apiService({
      url: "/claim/get_logs",
      method: "POST",
      data: payload,
    }).then((data: { url: string }) => {
      if (data.url) {
        window.location.href = data.url;
      }
    });
  }, [props.logKey]);

  return (
    <div className="response-segment">
      <div className="segment-name">Logs</div>
      <div className="row">
        <div className="col">
          <Button
            buttonStyle="outline"
            color="green"
            extraClasses="page-content-header-button"
            handleClick={handleLogsClick}
          >
            <span className="page-content-header-button-text">
              <span className="caprx-icon-paper-fold" />
              Download Logs
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResponseLogSegment;
